import React, {useState, useEffect} from 'react';
import {getAll} from '../../../../services/CollaborateurService';

import { Autocomplete, TextField, CircularProgress } from '@mui/material';
const ITEMS_PER_PAGE = 10;

const CollaborateurSelect = ({value, onChange}) => {
    const [inputValue, setInputValue] = useState('');
    const [options, setOptions] = useState([]);
    const [loading, setLoading] = useState(false);

    const fetchOptions = async (search = '') => {
        setLoading(true);
        try {
            const response = await getAll({
                page: 1,
                limit: ITEMS_PER_PAGE,
                search,
                years: [],
                contrats: [],
            });

            const collaborateurs = response.data.data;

            setOptions(
                collaborateurs.map((c) => ({
                    label: `${c.nom} ${c.prenom}`,
                    id: c.id,
                    ...c,
                }))
            );
        } catch (e) {
            console.error('Erreur lors du chargement des collaborateurs', e);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        const timeout = setTimeout(() => {
            fetchOptions(inputValue);
        }, 500);

        return () => clearTimeout(timeout);
    }, [inputValue]);

    return (
        <Autocomplete
            options={options}
            value={value}
            onChange={(event, newValue) => onChange(newValue)}
            inputValue={inputValue}
            onInputChange={(event, newInputValue) => setInputValue(newInputValue)}
            getOptionLabel={(option) => option.label || ''}
            isOptionEqualToValue={(option, value) => option.id === value?.id}
            loading={loading}
            renderInput={(params) => (
                <TextField
                    {...params}
                    label="Rechercher un collaborateur..."
                    variant="outlined" slotProps={{ ...params.slotProps, input: { ...params.slotProps?.input, ...({
                        ...params.slotProps.input,
                        endAdornment: (
                            <>
                                {loading ? <CircularProgress color="inherit" size={20}/> : null}
                                {params.slotProps.input?.endAdornment}
                            </>
                        ),
                    }) } }}
                />
            )}
        />
    );
};

export default CollaborateurSelect;
